import { connect, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import Recaptcha from "react-recaptcha";

import { FeatureFlagEnum } from "@/features/feature-flag/constants";
import InputError from "@/components/UI/InputError";

const Captcha = ({ setCaptchaVerificationToken }) => {
  const [recaptchaError, setRecaptchaError] = useState(null);
  const [mounted, setMounted] = useState(false);
  const EDGE_CASE = 397;

  let reCaptchaRef = React.createRef();
  const publicFlags = useSelector((state) => state.flags.publicFlags);
  const publicFlagsHaveLoaded = useSelector((state) => state.flags.publicFlagsHaveLoaded);

  useEffect(() => {
    setTimeout(() => {
      setMounted(true);
    }, 500);

    if (publicFlags?.[FeatureFlagEnum.recaptchaOverride]) {
      setCaptchaVerificationToken(true);
    }
  }, [publicFlagsHaveLoaded]);

  return (
    <div className="my-3 text-center w-100">
      <div>
        {mounted && (
          <Recaptcha
            className="mx-auto recaptcha"
            ref={reCaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            size={window.innerWidth < EDGE_CASE ? "compact" : "normal"}
            verifyCallback={async (response) => {
              setRecaptchaError(null);
              setCaptchaVerificationToken(response);
            }}
          />
        )}
      </div>
      <div className="text-center my-2">
        {recaptchaError && (
          <InputError style={{ position: "relative" }}>{recaptchaError}</InputError>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    configs: state.configs,
  };
};

export default connect(mapStateToProps, {})(Captcha);
